export default __webpack_public_path__ + "static/media/carouselOne.fa27c7f2.png";